// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bd8a079e","977":"9ccfda1a"}[chunkId] + ".chunk.js";
};